import { c as _c } from "react/compiler-runtime";
import { Box, ButtonBase, Typography } from '@mui/material';
import { IconButton } from '@/components/form/baseInputs/Button/IconButton';
import { Trash01Icon } from '@/components/icons/Trash01Icon';
import { COLORS } from '@/styles/tokens/colors';
import type { AnswerReviewEvidence } from './AnswerReviewWorkbench.types';
interface AnswerReviewEvidenceCarouselProps {
  fieldId: string;
  fieldLabel: string;
  evidence: AnswerReviewEvidence[];
  citationIndex: number;
  onSelectEvidence?: (fieldId: string, evidence: AnswerReviewEvidence) => void;
  onRemoveEvidence?: (fieldId: string, evidence: AnswerReviewEvidence) => void;
}
export function AnswerReviewEvidenceCarousel(t0) {
  const $ = _c(28);
  const {
    fieldId,
    fieldLabel,
    evidence,
    citationIndex,
    onSelectEvidence,
    onRemoveEvidence
  } = t0;
  const activeIndex = Math.min(citationIndex, Math.max(0, evidence.length - 1));
  const citation = evidence[activeIndex];
  if (!citation) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      color: COLORS.TEXT.SECONDARY
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== citation.quote) {
    t2 = <Typography component="blockquote" variant="body-xs" fontStyle="italic" m={0} sx={t1}>“{citation.quote}”</Typography>;
    $[1] = citation.quote;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = !onSelectEvidence;
  let t4;
  if ($[3] !== citation || $[4] !== fieldId || $[5] !== onSelectEvidence) {
    t4 = () => onSelectEvidence?.(fieldId, citation);
    $[3] = citation;
    $[4] = fieldId;
    $[5] = onSelectEvidence;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      textAlign: "left",
      minWidth: 0,
      borderRadius: 0.5,
      mt: 0.5
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      color: COLORS.TEXT.SECONDARY,
      overflowWrap: "anywhere"
    };
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== citation.documentName || $[10] !== citation.pageLabel || $[11] !== citation.referenceLabel) {
    t7 = [citation.referenceLabel, citation.pageLabel, citation.documentName].filter(Boolean);
    $[9] = citation.documentName;
    $[10] = citation.pageLabel;
    $[11] = citation.referenceLabel;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const t8 = t7.join(" - ");
  let t9;
  if ($[13] !== t8) {
    t9 = <Typography variant="body-xs" sx={t6}>{t8}</Typography>;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t3 || $[16] !== t4 || $[17] !== t9) {
    t10 = <ButtonBase type="button" disabled={t3} onClick={t4} sx={t5}>{t9}</ButtonBase>;
    $[15] = t3;
    $[16] = t4;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== citation || $[20] !== fieldId || $[21] !== fieldLabel || $[22] !== onRemoveEvidence) {
    t11 = citation.origin === "USER" && onRemoveEvidence && <IconButton size="xs" variant="transparent" icon={Trash01Icon} ariaLabel={`Remove citation for ${fieldLabel}`} onClick={() => onRemoveEvidence(fieldId, citation)} />;
    $[19] = citation;
    $[20] = fieldId;
    $[21] = fieldLabel;
    $[22] = onRemoveEvidence;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t10 || $[25] !== t11 || $[26] !== t2) {
    t12 = <Box borderLeft={`2px solid ${COLORS.GRAY[300]}`} pl={1}>{t2}{t10}{t11}</Box>;
    $[24] = t10;
    $[25] = t11;
    $[26] = t2;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  return t12;
}